import { isRecord } from '@/utils/filter/isRecord';

/**
 * Unwraps the S3 filter response envelope.
 * Some responses wrap the actual filter data inside a `filters` property.
 */
export const unwrapS3Response = (responseData: Record<string, unknown>): Record<string, unknown> => {
  const filters = responseData.filters;
  return isRecord(filters) ? filters : responseData;
};

/**
 * Validates that a download URL points to an expected S3 host.
 * Throws if the hostname is not an amazonaws.com domain.
 */
export const validateS3Url = (url: string): void => {
  const parsed = new URL(url);
  if (!parsed.hostname.endsWith('.amazonaws.com')) {
    throw new Error('Invalid download URL');
  }
};
